import { extractHEX, extractRGB, extractHSL, propBezInterpolate, returnRGBStr, returnHSLStr } from './utils';
import { defaultOptions } from './defaultOptions';
export function gradStop(options) {
    options = Object.assign({}, defaultOptions, options);
    if (options.stops < options.colorArray.length) {
        throw new Error('Number of stops cannot be less than colorArray.length');
    }
    return computeStops(options);
}
// computeStops
export var computeStops = function (options) {
    var outputArray = [];
    var init = function (opts) {
        switch (options.inputFormat) {
            case 'hex':
                return extractHEX(opts.colorArray);
            case 'rgb':
                return extractRGB(opts.colorArray);
            case 'hsl':
                return extractHSL(opts.colorArray);
        }
    };
    var stopsGenerator = function (opts) {
        var colorArray = opts.colorArray;
        var inc = 1.0 / (opts.stops - 1);
        var t = 0;
        for (var i = 0; i < opts.stops; i++) {
            if (opts.inputFormat === 'hex' || options.inputFormat === 'rgb') {
                var _a = propBezInterpolate(['r', 'g', 'b'])(colorArray)(t), r = _a[0], g = _a[1], b = _a[2];
                outputArray.push(returnRGBStr([r, g, b]));
            }
            else if (opts.inputFormat === 'hsl') {
                var _b = propBezInterpolate(['h', 's', 'l'])(colorArray)(t), h = _b[0], s = _b[1], l = _b[2];
                outputArray.push(returnHSLStr([h, s, l]));
            }
            t += inc;
        }
    };
    options.colorArray = init(options);
    stopsGenerator(options);
    return outputArray;
};
//# sourceMappingURL=index.js.map